import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col, Accordion } from 'react-bootstrap';
import './TaskSchedulerModal.css';

const TaskSchedulerModal = ({ show, onHide }) => {
    const [recurrenceType, setRecurrenceType] = useState('Day(s)');
    const [recurrenceEvery, setRecurrenceEvery] = useState(1);
    const [advancedOptions, setAdvancedOptions] = useState({});
    const [executionHours, setExecutionHours] = useState('');
    const [executionMinutes, setExecutionMinutes] = useState('');
    const [daysOfWeek, setDaysOfWeek] = useState({
        Sun: false,
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
    });
    const [monthDays, setMonthDays] = useState([]);
    const [isActivated, setIsActivated] = useState(false);

    const toggleDay = (day) => {
        setDaysOfWeek((prev) => ({ ...prev, [day]: !prev[day] }));
    };

    const toggleMonthDay = (day) => {
        setMonthDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };

    const renderAdvancedOptions = () => {
        switch (recurrenceType) {
            case 'Day(s)':
                return (
                    <Row>
                        <Col>
                            <Form.Label>Execute at these times</Form.Label>
                            <Row>
                                <Col>
                                    <Form.Control
                                        type="number"
                                        placeholder="Hours (UTC)"
                                        value={executionHours}
                                        onChange={(e) => setExecutionHours(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Form.Control
                                        type="number"
                                        placeholder="Minutes (UTC)"
                                        value={executionMinutes}
                                        onChange={(e) => setExecutionMinutes(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                );

            case 'Week(s)':
                return (
                    <>
                        <Row>
                            <Col>
                                <Form.Label>Run on these days</Form.Label>
                                <div className="d-flex">
                                    {Object.keys(daysOfWeek).map((day) => (
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            key={day}
                                            label={day}
                                            checked={daysOfWeek[day]}
                                            onChange={() => toggleDay(day)}
                                        />
                                    ))}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                <Form.Label>Execute at these times</Form.Label>
                                <Row>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            placeholder="Hours (UTC)"
                                            value={executionHours}
                                            onChange={(e) => setExecutionHours(e.target.value)}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            placeholder="Minutes (UTC)"
                                            value={executionMinutes}
                                            onChange={(e) => setExecutionMinutes(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                );

            case 'Month(s)':
                return (
                    <>
                        <Row>
                            <Col>
                                <Form.Label>Execute on these days</Form.Label>
                                <div className="calendar-grid">
                                    {Array.from({ length: 31 }, (_, i) => i + 1).map((day) => (
                                        <Form.Check
                                            inline
                                            type="checkbox"
                                            key={day}
                                            label={day === 31 ? 'Last' : day}
                                            checked={monthDays.includes(day)}
                                            onChange={() => toggleMonthDay(day)}
                                        />
                                    ))}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col>
                                <Form.Label>Execute at these times</Form.Label>
                                <Row>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            placeholder="Hours (UTC)"
                                            value={executionHours}
                                            onChange={(e) => setExecutionHours(e.target.value)}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            placeholder="Minutes (UTC)"
                                            value={executionMinutes}
                                            onChange={(e) => setExecutionMinutes(e.target.value)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            dialogClassName="task-scheduler-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>Task Scheduler</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="mb-3">
                        <Col>
                            <Form.Label>Recurrence</Form.Label>
                            <Row>
                                <Col>
                                    <Form.Label>Every</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        value={recurrenceEvery}
                                        onChange={(e) => setRecurrenceEvery(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Form.Label>&nbsp;</Form.Label>
                                    <Form.Select
                                        value={recurrenceType}
                                        onChange={(e) => setRecurrenceType(e.target.value)}
                                    >
                                        <option>Day(s)</option>
                                        <option>Week(s)</option>
                                        <option>Month(s)</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Accordion className="mb-3">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Advanced recurrence options</Accordion.Header>
                            <Accordion.Body>{renderAdvancedOptions()}</Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    {/* <Row>
                        <Col>
                            <Form.Check
                                type="checkbox"
                                label="Activated"
                                checked={isActivated}
                                onChange={(e) => setIsActivated(e.target.checked)}
                            />
                        </Col>
                    </Row> */}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => console.log('Save Trigger')}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TaskSchedulerModal;
